import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function HeartPulseIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.9915 4.48311C9.45238 -1.22151 1.13803 3.79073 1.00169 10.5856C0.966947 12.3173 1.46812 14.0042 2.46572 15.5593H8.93187L10.082 13.6473C10.4159 13.0922 11.2241 13.0743 11.577 13.6277L14.0036 17.431L17.5408 9.98302C17.8493 9.33313 18.7686 9.3125 19.1088 9.9427L22.1409 15.5593H29.5172C34.9814 7.0413 24.1824 -2.66242 15.9915 4.48311Z"
        fill="currentColor"
      />
      <path
        d="M20.8423 16.8514L18.3853 12.3002L14.9109 19.616C14.6153 20.2385 13.7459 20.2925 13.3752 19.7114L10.8576 15.7655L10.183 16.8868C10.0242 17.1508 9.73818 17.3123 9.42947 17.3123H3.85599C4.0307 17.4947 3.09954 16.5678 15.3716 28.7449C15.7143 29.085 16.2684 29.0851 16.6112 28.7449C28.6945 16.7552 27.9525 17.4944 28.1268 17.3123H21.616C21.2927 17.3124 20.9955 17.1353 20.8423 16.8514Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
